"use strict";

let g_card_sn = null;
let g_card_sign = null;

const POLL_TIMEOUT = 500;

export default class RFID_Connector {
    constructor( space ) {
        this._card_exist = false;

        this._terminal_number = '000000';

        this._card_attach_callback = null;
        this._card_remove_callback = null;
        this.space = space

        const $need_remove = space.s('card:need_remove', false);
        //space.s( 'card:remove' ).map(() => false).to($need_remove);
        // space.s( 'card:remove' )
        //     .withLatestFrom($need_remove, (_, need) => need)
        //     .filter(need => need)
        //     .map(() => false)
        //     .to($need_remove);
        space.s('card:absend_rfid').filter(absent => absent).map(() => false).to($need_remove);
        space.s('lobby_ui:stopPari').map(() => true).to($need_remove);
    }

    setCardAttachCallback(cb) {
        this._card_attach_callback = cb
    };

    setCardRemoveCallback(cb) {
        this._card_remove_callback = cb
    };

    resetCard() {
        this.setCard(null);
        this._card_exist = false;
    }

    //возвращаем признак того, что карта сменилась
    setCard(card) {

        let changeCard = false;
        if (card && g_card_sn !== card.id) {
            changeCard = true;
        }

        g_card_sn = card ? card.id : null;
        g_card_sign = card ? card.sign : null;

        return changeCard;
    };

    onCardExist(card, terminal_id) {

        let isChanged = this.setCard(card);

        if (!this._card_exist || isChanged) {

            console.log('ATTACH CARD');

            this._card_exist = true;
            this.space.s( 'card:attach' ).next({
                terminal_id,
                card_sn : card.id,
                sign : card.sign,
                isChanged,
            })
        }

       // this.tryRfidRequest();
    };

    onCardAbsent() {
        if (this._card_exist) {

            console.log('REMOVE CARD');

            this._card_exist = false;
            this.space.s( 'card:remove' ).next()

        }
        this.resetCard();

        //this.tryRfidRequest();
    };

    onRfidAbsent() {
        this.resetCard();
        this.space.s('card:absend_rfid').next(true);

        this._terminal_number = '000000';
        this.space.s('card:terminal_id').next(this._terminal_number);

        //this.tryRfidRequest();
    };

    rfid_server_info_default(data) {
        //console.log("rfid info default", data);
        if(data.devices !== undefined && data.devices.length > 0) {
            this.space.s('card:absend_rfid').next(false);
            if (data.terminal_sn && data.terminal_sn != this._terminal_number) {
                this._terminal_number = data.terminal_sn;
                this.space.s('card:terminal_id').next(this._terminal_number);
            }
            if(data.devices[0] !== undefined && data.devices[0].availableCards[0] !== undefined) {
                this.onCardExist(data.devices[0].availableCards[0], data.terminal_sn);
            } else {
                this.onCardAbsent();
            }
        } else {
            this.onRfidAbsent(data);
        }

        this.tryRfidRequest();
    };

    makeRfidRequest() {

        // if(stop_poll)
        //    return;
        // Using YQL and JSONP
        $.ajax({
            url: "http://localhost:8888/getRfid",
            // The name of the callback parameter, as specified by the YQL service
            jsonp: "callback",
            // Tell jQuery we're expecting JSONP
            dataType: "jsonp",
            // Tell YQL what we want and that we want JSON
            data: {
                q: "select title,abstract,url from search.news where query=\"cat\"",
                format: "json"
            },
            // Work with the response
            success: ( response ) => {
                this.rfid_server_info_default(response);
            },
            error: (err) => {
                console.log('ERROR RFID DAEMON REQUEST', err);
                this.onRfidAbsent(null);
                this.tryRfidRequest();
            }
        });
    };

    tryRfidRequest( instant ) {
        setTimeout(() => {
            this.makeRfidRequest()
        }, instant ? 0 : POLL_TIMEOUT )
    };
}



// WEBPACK FOOTER //
// ./src/rfid_daemon_connector.es6